module.exports = __webpack_public_path__ + "img/body-3.cbb8fa24.png";